import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({

    /* Background */
    st0: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor || '#1CB1F9',
        };
    },

    /* font color */
    st12: (props) => {
        const {
            fontColor,
        } = props;

        return {
            fill: fontColor || '#FFFFFF',
        };
    },

    st1: (props) => {
        const {
            backgroundColor,
        } = props;

        return {
            fill: backgroundColor || '#1CB1F9',
            filter: 'brightness(0.85)',
        };
    },

    st2: {
        fill: '#FFFFFF',
    },

    st3: {
        fill: 'url(#SVGID_3_)',
    },

    st4: {
        fill: '#F28C00',
    },

    st5: {
        fill: '#EE7624',
    },

    st6: {
        fill: '#009BE0',
    },

    st7: {
        fill: '#01BFD7',
    },

    st8: {
        fill: '#F9BF01',
    },

    st9: {
        fill: '#76BD22',
    },

    st10: {
        fill: '#00A8E2',
    },

    st11: {
        fill: 'none',
    },

    st13: {
        fontFamily: 'Roboto, sans-serif',
    },

    st14: {
        fontSize: '15px',
    },

}));
